import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import { useIsAuthenticated } from './hooks';
import { AdminMenuGate } from './components/common/AdminMenuGate';
import {
  AccountDetails,
  AccountStatement,
  AccountSummary,
  ActivityLog,
  ActivityLogs,
  AffiliateListing,
  AffiliateReq,
  AllDownlineListing,
  BankerDashboard,
  BankerDetail,
  BannerManagement,
  BetList,
  BetSetting,
  BussinessReports,
  CasinoBetList,
  CasinoControl,
  CasinoDetail,
  CasinoPlByDownline,
  CasinoPlByPlayer,
  CategoryControl,
  ComissionReport,
  AffiliateActiveUserOfWeek,
  ContentManagement,
  DashBoard,
  DashboardPage,
  DWRequest,
  EventManagement,
  Export,
  FilteredGames,
  GameControl,
  InactiveMemerList,
  Login,
  ManageAccount,
  NotFoundPage,
  NotificationManagement,
  OnboardingPage,
  PlByEvent,
  PlByPlayer,
  PlDownline,
  ProviderControl,
  Risk,
  Setting,
  SubUsers,
  SubUsersListing,
  SupportContactManagement,
  TransactionCode,
  TransactionHistory,
  UserAccountStatement,
  UserBetHistory,
  UserBettingPL,
  AuthLayout,
  DashboardLayout,
  RoleWiseAccountStatement,
  BonusStatement,
  PolicyManagement,
  PaymentSettings,
  FdManagement,
  DiamondEvents,
  UserDetailsPage,
  UsersListPage,
  NewDashboardPage,
  AffiliateSetting,
  AppManagement,
  BrandManagement,
} from '@/components/routes';

export function App() {
  // useEffect(() => {
  //   const bankerDomain = import.meta.env.VITE_BANKER_URL;
  //   const adminDomain = import.meta.env.VITE_ADMIN_URL;

  //   if (location.href.includes(bankerDomain)) {
  //     document.title = 'Rebel Exchange Banker';
  //   } else if (location.href.includes(adminDomain)) {
  //     document.title = 'Rebel Exchange Admin/Agent';
  //   }
  // }, []);

  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        {/* One door. The form posts the `panel` portal, and the server refuses
            any player account there, so a single username and password lands
            each role wherever their account belongs. */}
        <Route path="/login" element={<Login />} />
        {/* The per-role pages that used to live here: keep old links and
            bookmarks working rather than dropping them on the 404. */}
        <Route path="/login/:portal" element={<Navigate to="/login" replace />} />
        {/* <Route path="/register" element={<RegisterPage />} /> */}
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        {/* Per-brand panel access: a section the super admin switched off is not
            reachable by URL either, not just missing from the rail. */}
        <Route element={<AdminMenuGate />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/new-dashboard" element={<NewDashboardPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          {/* Downline Routes */}
          <Route path="/members/:id" element={<AllDownlineListing />} />
          <Route path="/members/:id/:user/:memberid/:upline" element={<SubUsers />} />
          <Route path="/members/:id/sub/:memberid" element={<AccountDetails />}>
            <Route index element={<AccountSummary />} />
            <Route path="account-summary" element={<AccountSummary />} />
            <Route path="account-statement" element={<UserAccountStatement />} />
            <Route path="bet-history" element={<UserBetHistory />} />
            <Route path="betting-pl" element={<UserBettingPL />} />
            <Route path="casino-detail" element={<CasinoDetail />} />

            <Route path="transaction-history" element={<TransactionHistory />} />
            <Route path="login-history" element={<ActivityLog />} />
          </Route>

          {/* Banker Management */}
          <Route path="/bankers/:id/:details?/:mode?/:type?" element={<BankerDetail />} />
          <Route path="/requests/:mode?/:type?" element={<DWRequest />} />
          <Route path="/manage-account/:type?" element={<ManageAccount />} />
          <Route path="/payment" element={<PaymentSettings />} />
          <Route path="/fd" element={<FdManagement />} />
          <Route path="/brands" element={<BrandManagement />} />
          {/* <Route path="/account-statement" element={<AccountStatement />} /> */}
          <Route path="/banker-dashboard" element={<BankerDashboard />} />

          {/* Content Management */}
          <Route path="/content-management" element={<ContentManagement />}>
            <Route index element={<BannerManagement />} />
            <Route path="Notification" element={<NotificationManagement />} />
            <Route path="Contact" element={<SupportContactManagement />} />
          </Route>

          {/* Affiliate Management */}
          <Route path="/affiliate-dashboard" element={<DashBoard />} />
          <Route path="/affiliate-req" element={<AffiliateReq />} />
          <Route path="/affiliate-list" element={<AffiliateListing />} />
          <Route path="/affiliate-list/:id" element={<SubUsersListing />} />
          <Route path="/affiliate-comission-report" element={<ComissionReport />} />
          <Route path="/affiliate-comission-report/:id" element={<AffiliateActiveUserOfWeek />} />
          <Route path="/affiliate-setting" element={<AffiliateSetting />} />

          {/* Casino management */}
          <Route path="/casino-management" element={<CasinoControl />}>
            <Route index element={<CategoryControl />} />
            <Route path="provider" element={<ProviderControl />} />
            <Route path="game" element={<GameControl />} />
          </Route>
          <Route path="/casino-management/games" element={<FilteredGames />} />

          {/* Change Password Routes */}
          <Route path="/settings" element={<Setting />} />

          {/* Event Management*/}
          <Route path="/event-management/:status?" element={<EventManagement />} />
          <Route path="/diamond-events" element={<DiamondEvents />} />
          <Route path="/bet-setting" element={<BetSetting />} />

          {/* Risk Management Routes */}
          <Route path="/risk" element={<Risk />} />

          {/* Reports Routes */}
          <Route path="/bet-list" element={<BetList />} />
          <Route path="/casino-bet-list" element={<CasinoBetList />} />
          <Route path="/pl-by-downline" element={<PlDownline />} />
          <Route path="/pl-by-player" element={<PlByPlayer />} />
          <Route path="/pl-by-event" element={<PlByEvent />} />
          <Route path="/casinopl-by-player" element={<CasinoPlByPlayer />} />
          <Route path="/casinopl-by-downline" element={<CasinoPlByDownline />} />
          <Route path="/activity-logs" element={<ActivityLogs />} />
          <Route path="/inactive-members" element={<InactiveMemerList />} />
          <Route path="/business-reports" element={<BussinessReports />} />

          {/* App Management */}
          <Route path="/app-management" element={<AppManagement />} />

          {/* Export History */}
          <Route path="/export" element={<Export />} />

          {/* Account statement */}
          <Route path="/account-statement" element={<RoleWiseAccountStatement />} />
          {/* User Management */}
          <Route path="/users" element={<UsersListPage />} />
          <Route path="/users/:id" element={<UserDetailsPage />} />

          {/* Bonus Management */}
          <Route path="/bonus">
            <Route path="policy-management" element={<PolicyManagement />} />
            <Route path="statement" element={<BonusStatement />} />
          </Route>
        </Route>
        </Route>
      </Route>
      {/* </Route> */}
      <Route path="/transaction-code" element={<TransactionCode />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
